import React from "react";
import { useNavigate } from "react-router-dom";
import { Grid, Paper, Typography, Stack, TextField, Button, Divider } from "@mui/material";

interface TagsOverviewProps {
    tagsCount: number;
    query: string;
    setQuery: (query: string) => void;
}

const TagsOverview: React.FC<TagsOverviewProps> = ({ tagsCount, query, setQuery }) => {
    const navigate = useNavigate();

    function handleCreateTag() {
        // navigate to NewTag page with the entered text
        navigate("/tags/new", { state: { enteredText: query } });
    }

    return (
        <Paper
            sx={{
                p: 2,
                display: "flex",
                flexDirection: "column",
                height: "100%",
            }}
        >
            <Grid container spacing={2}>
                <Grid item xs={12} m={2}>
                    <Stack direction={"column"} spacing={2}>
                        <Typography variant="h4">Tags</Typography>
                        <Typography variant="body1">You can search for existing tags here.</Typography>
                        <Typography variant="h6">{tagsCount} Tags</Typography>
                    </Stack>
                </Grid>

                <Grid item xs={12}>
                    <Divider />
                </Grid>

                {/* Search field */}
                <Grid item xs={12} m={2}>
                    <Stack direction={"row"} spacing={2}>
                        {/* Search field */}
                        <TextField
                            onChange={(e) => setQuery(e.target.value)}
                            value={query}
                            placeholder="Filter by tag name"
                            autoComplete="off"
                        />
                        {/* Create new tag */}
                        <Button variant="contained" color="primary" onClick={handleCreateTag}>
                            Create new tag
                        </Button>
                    </Stack>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default TagsOverview;
